import React from 'react';
import useGetSouscriptionCompanyQuery from './hooks/useGetSouscriptionCompanyQuery.js';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import { Loading } from '@fasstech/middle-design-system';
import SouscriptionCompanyForm from './SouscriptionCompanyForm.jsx';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import { compose } from 'ramda';

const SouscriptionCompany = ({ getMiddleText, getMiddleBoolean, phoneIndicatives }) => {
  const { getSouscriptionCompany, loading: isFetchingGetSouscriptionCompany } =
    useGetSouscriptionCompanyQuery();

  if (isFetchingGetSouscriptionCompany) return <Loading />;

  return (
    <SouscriptionCompanyForm
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      getSouscriptionCompany={getSouscriptionCompany}
      phoneIndicatives={phoneIndicatives}
    />
  );
};

export default compose(withMiddleFeatures, withGlobalData)(SouscriptionCompany);
